import { Textbox } from "components/Textbox/Textbox";
import { useEffect, useRef, useState } from "react";
import {
  GroupingPriceFunction,
  padWithZeros,
  RoundWithRoundingPlace,
  trans,
  validateInput,
  validateInputAsNumber,
} from "utils/helpers";
import { REGEX } from "utils/regex";
import "./style.scss";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
interface PriceInputPropsType {
  label?: string;
  resetForm?: boolean;
  required?: boolean;
  value?: any;
  mode?: string;
  name: string;
  Change?: (e) => void;
  onChange?: (e) => void;
  useCallForPrice?: boolean;
  defaultValue?: any;
  min?: number;
  decimals?: any;
  round?: any;
  useTrans?: any;
  max?: any;
  asNumber?: any;
  withLabel?: any;
  placeholder?: any;
  customClass?: any;
  readonly?: any;
  minLength?: any;
  maxLength?: any;
  useOnInput?: boolean;
  autoFocus?: boolean;
  customValidation?: any;
  useEval?: boolean;
  onBlurHandler?: (ans: any) => void;
  UsepadWithZeros?: boolean;
  sqlInjection?: boolean;
  capsLock?: boolean;
  usePrevDefaultValue?: any;
  withMsg?: boolean;
  recordedData?: any;
  CallForPriceText?:any
}

export const PriceInput = ({
  label,
  defaultValue,
  useCallForPrice = false,
  value,
  mode,
  resetForm,
  required,
  name = "",
  Change,
  onChange,
  min,
  decimals = null,
  round,
  useTrans = true,
  max,
  asNumber,
  withLabel = true,
  placeholder,
  customClass,
  readonly,
  minLength,
  maxLength,
  useOnInput = false,
  autoFocus,
  UsepadWithZeros,
  customValidation = null,
  capsLock,
  onBlurHandler,
  useEval = true,
  sqlInjection = true,
  usePrevDefaultValue,
  withMsg = true,
  recordedData,
  CallForPriceText=null
}: PriceInputPropsType) => {
  const [valueName, setValueName] = useState<any>();
  const [valueNum, setValueNum] = useState<any>(CallForPriceText || "تماس بگیرید");
  const [flag, setFlag] = useState(false);
  const [show, setShow] = useState(false);
  const [validat, setValidat] = useState(false);
  const [count, setCount] = useState<number>(0);
  const inputRef = useRef<any>();
  const inputIdRef = useRef<any>();
  const validRef = useRef<any>(false);
  const countRef = useRef<any>(0);
  let optionList: any = [{ title:CallForPriceText?CallForPriceText: trans("CallForPrice"), value: -1 }];
  const [TEXTBOX_VAL, setTEXTBOX_VAL] = useState(
    defaultValue == 0 ? defaultValue + "" : defaultValue
  );
  const disabled = mode == "view" ? true : readonly ? true : false;
  let [regexMsgShow, setRegexMsgShow] = useState<boolean>(false);
  let [maxLengthMsgShow, setMaxLengthMsgShow] = useState<boolean>(false);
  let [requiredMsgShow, setRequiredMsgShow] = useState<boolean>(false); // check and delete unnecessary state

  const Auto = (e) => {
    validRef.current = false;
    inputIdRef.current.value = e.target.value;
    if (isNaN(+e.target.value) && !e.target.value.includes(",")) {
      inputRef.current.value = "";
    } else {
      onChange && onChange(e.target.value.replaceAll(",", ""));
      setValueNum(e.target.value);
      setValidat(false);
    }
    setShow(true);
    setFlag(!flag);
  };

  function userSelecter() {
    setValeu(optionList[countRef.current], -1);
    setShow(false);
  }

  const kydown = (event) => {
    if (event.key === "ArrowDown") {
      if (countRef.current < optionList.length - 1) {
        countRef.current = countRef.current + 1;
      } else {
        countRef.current = 0;
      }
    }

    if (event.key === "ArrowUp") {
      if (countRef.current > 0) {
        countRef.current = countRef.current - 1;
      } else {
        countRef.current = optionList.length - 1;
      }
    }
    document
      .getElementById("PriceInput" + countRef.current)
      ?.scrollIntoView({ behavior: "smooth" });
    setCount(countRef.current);

    if (event.key === "Enter") {
      userSelecter();
    }
  };
  const CheckPriceList = async (e) => {
    setTimeout(() => {}, 200);
    await delay(200);
    if (!document.activeElement?.className.includes("")) {
      setShow(false);
    }
  };
  const delay = (duration) =>
    new Promise((resolve) => setTimeout(resolve, duration));

  const setValeu = (newValue, id) => {
    if (inputIdRef != null && inputIdRef.current != null) {
      validRef.current = true;
      inputRef.current.value = newValue;
      inputIdRef.current.value = id;
      (value == null && id) || id != value
        ? Change && Change({ [name]: id })
        : Change && Change({ [name]: null });
      onChange && onChange({ Name: newValue, Id: id });
      setFlag(!flag);
      setValidat(false);
    }
  };

  function clickToclose(e) {
    let input = document.querySelector("#browser" + name);
    if (e.target.id !== input?.id) {
      setShow(false);
    }
  }

  useEffect(() => {
    if (useCallForPrice) {
      if (value) {
        if (value == "-1") {
          inputIdRef.current.value = -1;
          setValueName(CallForPriceText?CallForPriceText:trans("CallForPrice"));
          setValueNum(CallForPriceText?CallForPriceText:trans("CallForPrice"));
        }
      } else if (value == null) {
        setValueName(null);
      }
    }
  }, [value, resetForm]);

  useEffect(() => {
    if (show && useCallForPrice) {
      document.addEventListener("keydown", kydown);
      document.body.addEventListener("click", clickToclose);
    }
    return () => {
      document.removeEventListener("keydown", kydown);
      document.body.removeEventListener("click", clickToclose);
    };
  }, [show, optionList]);

  ///////////////////////////////useCallForPrice==false////////////////////////////////////////

  function maxLengthCheck(e) {
    e.stopPropagation();
    if (maxLength !== undefined && maxLength) {
      if (TEXTBOX_VAL && TEXTBOX_VAL?.length > maxLength) {
        // چون ست کردن یوز استیت یک قدم عقب تر است شرط == جواب میدهد
        e.target.setCustomValidity(trans("Msg_Validation_InvalidMaxLength"));
        e.target.reportValidity();
        setMaxLengthMsgShow(true);
        let id = setTimeout(() => {
          setMaxLengthMsgShow(false);
        }, 2000); // هشدار حداکثر طول بعد از 3 ثانیه ناپدید می شود
      } else {
        if (maxLengthMsgShow) e.target.setCustomValidity("");
      }
    }
  }

  function Checkrequired(event) {
    maxLengthCheck(event);
    if (event.target.value.length == 0 && required) {
      setRequiredMsgShow(true);
    }
    onBlurHandler && onBlurHandler(event.target.value);
    if (UsepadWithZeros && maxLength) {
      setTEXTBOX_VAL(
        padWithZeros(maxLength, event.target.value ? event.target.value : "")
      );
    }
    if (decimals != null && event.target.value) {
      setTEXTBOX_VAL(
        RoundWithRoundingPlace(
          +event.target.value.replaceAll(",", "")
            ? +event.target.value.replaceAll(",", "")
            : 0,
          decimals
        ) + ""
      );
    }
    // setTEXTBOX_VAL(event);
  }

  function checkRegexValidation(event) {
    const hasNewLine =
      event.target.value.includes("\n") || event.target.value.includes("\r"); //find enter key
    let newValue = event.target.value + "";
    if (hasNewLine) {
      // event.target.value=event.target.value.replace(/[\r\n]+/g, '')//remove enter key
    }
    setRequiredMsgShow(false);

    if (event.target.value != defaultValue) {
      Change &&
        Change({
          [name]: event.target.value.length == 0 ? " " : event.target.value,
        });
    } else {
      Change && Change({ [name]: null });
    }
    if (capsLock) {
      event.target.value = event.target.value.toUpperCase();
    }
    let valditaionRegex;
    let validationRegexResult;
    valditaionRegex = new RegExp(REGEX.text.regex);
    validationRegexResult = valditaionRegex.test(event.target.value);

    if (!validationRegexResult) {
      event.target.setCustomValidity(REGEX.text.valditionMsg);
      event.target.reportValidity();
      setRegexMsgShow(true);
    } else if (validationRegexResult) {
      event.target.setCustomValidity("");
      setRegexMsgShow(false);
    }

    if (
      (customValidation && !customValidation(event.target.value)?.invalid) ||
      !customValidation
    ) {
      if (
        (validateInput(event.target.value) && !asNumber) ||
        (validateInput(event.target.value) &&
          asNumber &&
          validateInputAsNumber(event.target.value))
      ) {
        if (
          newValue &&
          useEval &&
          newValue.endsWith("=") &&
          newValue.startsWith("=") &&
          newValue.length > 1
        ) {
          newValue = newValue.replaceAll("=", "");
          newValue = eval(newValue) + "";
          inputRef.current.value = newValue;
        }
        if (decimals != null && inputRef.current) {
          inputRef.current.value = RoundWithRoundingPlace(
            +newValue.replaceAll(",", ""),
            decimals
          );
        }
        if (event.target.max && +newValue > +event.target.max) {
          event.target.setCustomValidity(
            trans("Msg_Validation_InvalidMaxLength")
          );
          event.target.reportValidity();
          setTEXTBOX_VAL(value.replaceAll(",", ""));
          onChange && onChange(event);
        } else if (event.target.min && +newValue < +event.target.min) {
          event.target.setCustomValidity(
            trans("msg_validation_valueisincorrect")
          );
          event.target.reportValidity();

          setTEXTBOX_VAL(event.target?.value.replaceAll(",", ""));
          onChange && onChange(event);
        } else {
          setTEXTBOX_VAL(newValue?.replaceAll(",", ""));
          onChange && onChange(event);
        }
      } else {
        if (!validateInput(event.target.value) && sqlInjection) {
          // onChange && onChange(event);
          if (!useOnInput) {
            setRegexMsgShow(true);
            event.target.setCustomValidity(trans("invalidcharacter"));
            event.target.reportValidity();
          }
          setTEXTBOX_VAL(newValue?.replaceAll(",", ""));
        }
      }
    } else {
      setRegexMsgShow(true);
      event.target.setCustomValidity(
        trans(customValidation(event.target.value)?.message)
      );
      event.target.reportValidity();
      setTEXTBOX_VAL(newValue?.replaceAll(",", ""));
    }
  }

  useEffect(() => {
    if (!useCallForPrice) {
      if (UsepadWithZeros && maxLength && defaultValue) {
        setTEXTBOX_VAL(padWithZeros(maxLength, defaultValue));
      } else {
        if (decimals != null && defaultValue) {
          setTEXTBOX_VAL(RoundWithRoundingPlace(+defaultValue, decimals) + "");
        } else {
          setTEXTBOX_VAL(defaultValue == 0 ? defaultValue + "" : defaultValue);
        }
      }
    }
  }, [defaultValue ,decimals]);

  useEffect(() => {
    if (resetForm && !useCallForPrice) setTEXTBOX_VAL(defaultValue);
  }, [resetForm]);

  useEffect(() => {
    if (usePrevDefaultValue && !useCallForPrice) {
      setTEXTBOX_VAL(RoundWithRoundingPlace(+defaultValue, decimals) + "");
    }
  }, [usePrevDefaultValue]);

  useEffect(() => {
    if (!useCallForPrice) {
      window.addEventListener(
        "keydown",
        (e) => {
          const target = e.target as HTMLElement;
          if (e.key === "Enter" && target.tagName !== "TEXTAREA") {
            e.preventDefault();
          }
        },
        true
      );
      return () => {
        window.removeEventListener(
          "keydown",
          (e) => {
            if (e.key === "Enter") {
              e.preventDefault();
            }
          },
          true
        );
      };
    }
  }, []);

  return (
    <>
      {useCallForPrice ? (
        <div className="text-box w-100">
          <label htmlFor={`browser${name}`} className="text-box__label">
            {trans(label ?? "")}
          </label>
          {required && (
            <span className="text-box__required-sign-for-label text-danger">
              *
            </span>
          )}
          <input
            required={required}
            defaultValue={value && value}
            name={name}
            className="d-none"
            ref={inputIdRef}
          />
          <input
            required={required}
            onBlur={CheckPriceList}
            defaultValue={valueName}
            value={GroupingPriceFunction(valueNum)}
            autoComplete="off"
            onFocus={(e) => {
              setShow(true);
              Auto(e);
            }}
            ref={inputRef}
            list="PriceInput"
            name="browser"
            className="text-box__box form-control "
            type={"text"}
            id={"browser" + name}
            onMouseDown={(e) => e.stopPropagation()}
            onChange={Auto}
            disabled={mode == "view" ? true : false}
          />
          {show && (
            <div tabIndex={-1} className={`text-box__sub-menu mt-1`}>
              {optionList &&
                optionList.map((item, index) => {
                  return (
                    <div
                      id={"PriceInput" + index}
                      className={`${
                        count == index
                          ? "text-box__sub-menu-option-active"
                          : "text-box__sub-menu-option"
                      }`}
                      onClick={() => {
                        setValeu(item.title, -1);
                        setValueNum(CallForPriceText?CallForPriceText:trans("CallForPrice"));
                      }}
                      key={item.value}
                    >
                      {item.title}
                    </div>
                  );
                })}
            </div>
          )}
          <div className="text-box__msg-wrapper">
            {required && (
              <span
                className={`${
                  validat ? "show-msg" : "hide-msg"
                } text-box__required-msg text-danger`}
              >
                {trans("Msg_Validation_ValueIsIncorrect")}
              </span>
            )}
          </div>
        </div>
      ) : (
        <div className="text-box w-100">
          <div className="d-flex w-100 justify-content-between">
            {withLabel && (
              <OverlayTrigger
                key={label}
                placement="top"
                delay={{ show: 100, hide: 0 }}
                overlay={
                  <Tooltip
                    className="tooltip"
                    id={`button-tooltip-${"checkable"}`}
                  >
                    {trans(label + "")}
                  </Tooltip>
                }
              >
                <div
                  className="d-flex  align-items-center"
                  style={{ height: "22px", width: "80%" }}
                >
                  {label && (
                    <label className="text-box__label showDots">
                      {useTrans ? trans(label) : label}
                    </label>
                  )}
                  {required && label && (
                    <span className="text-box__required-sign-for-label text-danger">
                      *
                    </span>
                  )}
                </div>
              </OverlayTrigger>
            )}
            {(false ||
              (mode == "edit" &&
                recordedData != undefined &&
                recordedData != TEXTBOX_VAL) ||
              (mode == "create" &&
                recordedData != TEXTBOX_VAL &&
                TEXTBOX_VAL != undefined &&
                TEXTBOX_VAL.length > 0 &&
                recordedData != undefined)) && (
              <>
                <OverlayTrigger
                  key={"reserve"}
                  placement="top"
                  delay={{ show: 600, hide: 0 }}
                  overlay={
                    <Tooltip
                      style={{ direction: "rtl" }}
                      className="tooltip "
                      id={`button-tooltip-${"reserve"}`}
                    >
                      {trans("PreviousValue") + " : " + recordedData}
                    </Tooltip>
                  }
                >
                  <span className="d-flex " style={{ maxWidth: "18%" }}>
                    <FontAwesomeIcon
                      style={{ marginRight: "5px" }}
                      icon={["fas", "circle-info"]}
                      className="text-primary pr-2"
                    />

                    <FontAwesomeIcon
                      onClick={() => {
                        setTEXTBOX_VAL(recordedData);
                        onChange && onChange({ recordedData });
                      }}
                      style={{ marginRight: "5px" }}
                      icon={["fas", "undo"]}
                      className="text-primary pr-2"
                    />
                  </span>
                </OverlayTrigger>
              </>
            )}
          </div>
          <OverlayTrigger
            key={label + " " + "value"}
            placement="top"
            offset={[5, 10]}
            delay={{ show: 100, hide: 0 }}
            overlay={
                mode == "view" &&
                TEXTBOX_VAL &&
                TEXTBOX_VAL?.length > 0 &&
                TEXTBOX_VAL ?   <Tooltip className="tooltip" id={`button-tooltip-${label}`}>
          
                  { TEXTBOX_VAL}
                 
              </Tooltip> : <></>
            }
          >
            <input
              ref={inputRef}
              autoFocus={autoFocus}
              id={name + "Id"}
              placeholder={placeholder}
              min={min}
              max={max}
              // step={step}
              pattern={REGEX.text.regex}
              onKeyDown={(e) => {
                e.stopPropagation();
              }}
              onBlur={Checkrequired}
              autoComplete="off"
              name={name}
              onMouseDown={(e) => e.stopPropagation()}
              value={TEXTBOX_VAL ? GroupingPriceFunction(TEXTBOX_VAL) : ""}
              type={"text"}
              className={` text-box__box 
                " form-control NumberFontSize" ${
                  required && " required-input"
                } ${customClass ? customClass : ""}`}
              onChange={(e) => {
                inputRef.current.focus();
                checkRegexValidation(e);
              }}
              onInput={
                useOnInput
                  ? (e) => {
                      checkRegexValidation(e);
                    }
                  : () => {}
              }
              maxLength={maxLength ? maxLength : undefined}
              minLength={minLength ? minLength : undefined}
              required={required}
              disabled={disabled}
            />
          </OverlayTrigger>

          {withMsg ? (
            <div className="text-box__msg-wrapper">
              {required && (
                <span
                  className={`${
                    requiredMsgShow ? "show-msg" : "hide-msg"
                  } text-box__required-msg text-danger`}
                >
                  {trans("Msg_Validation_ValueIsRequired", [""])}
                </span>
              )}

              <span
                className={`${
                  regexMsgShow ? "show-msg" : "hide-msg"
                } text-box__regex-msg text-danger`}
              >
                {TEXTBOX_VAL && TEXTBOX_VAL !== ""
                  ? REGEX.text.valditionMsg
                  : null}
              </span>
              {maxLength ? (
                <span
                  className={`${
                    maxLengthMsgShow ? "show-msg" : "hide-msg"
                  } text-box__max-length-msg text-danger`}
                >{`${trans("Msg_Validation_InvalidMaxLength")}`}</span>
              ) : (
                <></>
              )}
            </div>
          ) : (
            <></>
          )}
        </div>
      )}
    </>
  );
};
